import { IApiService } from 'src/services/IApiService';
import { observable, computed } from 'mobx';
import {Config} from 'src/Config';

export default class AuthStore {

    @observable public isAuthenticated: boolean = false;
    public token:string = 'notLoggedIn';
    public refreshToken:string = '';
    private baseURL: string = Config.baseURL;
    private baseURLTest: string = "https://krabicky-test.unknown.cz/rest";
    private baseURLProd: string = "https://unknown.cz/lucka/rest";
    public guiAccess: string[] = [];

    public auth(user: string, password: string): Promise<string> {
        return new Promise(resolve => {
            this.authCredentials(user, password)
                .then(res => {
                    if(res === 'failure') {
                        resolve('failure');
                    } else {
                        this.isAuthenticated = true;
                        setTimeout(() => {
                          this.refresh();
                        }, 1000000);
                        resolve(res);
                    }
                });
        });
    }

    public refresh(): Promise<string> {
        return new Promise(resolve => {
            this.authWithToken(this.refreshToken)
                .then(res => {
                    if(res === 'failure') {
                        resolve('failure');
                    } else {
                        this.isAuthenticated = true;
                        setTimeout(() => {
                          this.refresh();
                        }, 1000000);
                        resolve(res);
                    }
                });
        });
    }

    private authCredentials(user:string, password:string): Promise<string> {
      const authData = {
        'user': user,
        'password':password 
      }
      return this.authUser(authData);
    }

    private authWithToken(token:string): Promise<string> {
      const authData = {
        'token': token
      }
      return this.authUser(authData);
    }

    private authUser(authData): Promise<string> {
      return new Promise(resolve => {
        fetch(this.baseURL + '/auth.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(authData)})
        .then(resp => {
          resp.json().then(json => {
            if(json.status === 'success') {
              this.guiAccess = json.guiAccess;
              this.token = json.token;
              this.refreshToken = json.tokenRefresh;
              resolve(json.token);
            } else {
              resolve(json.status);
            }
          });
        })
      });
    }

    public hasGUIResource(res: string) {
      const result = this.guiAccess.findIndex((val: string) => val === res);
      // console.log("Check for " + res + " is " + result);
      return result !== -1;
    }

}


// WEBPACK FOOTER //
// ./src/stores/AuthStore.tsx